'use client'

import { useEffect, useState, useSyncExternalStore } from 'react'

export function useLoop(durationMs: number, paused = false): number {
  const [phase, setPhase] = useState(0)
  useEffect(() => {
    if (paused) return
    let raf = 0
    let start = 0
    const step = (ts: number) => {
      if (!start) start = ts
      setPhase(((ts - start) % durationMs) / durationMs)
      raf = requestAnimationFrame(step)
    }
    raf = requestAnimationFrame(step)
    return () => cancelAnimationFrame(raf)
  }, [durationMs, paused])
  return phase
}

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)'

function subscribeReducedMotion(onChange: () => void): () => void {
  const mq = window.matchMedia(REDUCED_MOTION_QUERY)
  mq.addEventListener('change', onChange)
  return () => mq.removeEventListener('change', onChange)
}

function getReducedMotionSnapshot(): boolean {
  return window.matchMedia(REDUCED_MOTION_QUERY).matches
}

function getReducedMotionServerSnapshot(): boolean {
  return false
}

export function usePrefersReducedMotion(): boolean {
  return useSyncExternalStore(subscribeReducedMotion, getReducedMotionSnapshot, getReducedMotionServerSnapshot)
}

export function useMockPhase(durationMs: number, staticPhase: number, paused = false): number {
  const reduced = usePrefersReducedMotion()
  const live = useLoop(durationMs, reduced || paused)
  return reduced ? staticPhase : live
}
